import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { useState } from 'react';
import Logo from './Logo';

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const handleScheduleCall = () => {
    window.open("https://calendly.com/kentfrazier/30-minutes", "_blank");
  };

  const handleLogoClick = (e: React.MouseEvent) => {
    e.preventDefault();
    setIsMenuOpen(false);
    if (location.pathname !== '/') {
      navigate('/', { replace: true });
    }
    window.scrollTo(0, 0);
  };

  const handleNavClick = () => {
    setIsMenuOpen(false);
    window.scrollTo(0, 0);
  };

  const navLinks = [
    { to: '/about', label: 'About' },
    { to: '/services', label: 'For Leaders' },
    { to: '/for-organizations', label: 'For Organizations' },
    { to: '/testimonials', label: 'Results' },
    { to: '/essays', label: 'Essays' },
  ];

  const isActive = (path: string) => location.pathname === path;

  return (
    <>
      <nav className="w-full bg-background fixed top-0 z-50 border-b border-border/50">
        <div className="w-full px-4 sm:px-6 md:px-8 lg:px-12">
          {/* Main Nav Row */}
          <div className="flex justify-between items-center h-20 sm:h-24">
            {/* Logo */}
            <Link
              to="/"
              className="transition-all hover:opacity-80 flex-shrink-0"
              onClick={handleLogoClick}
              aria-label="ParadoxEdge home"
            >
              <Logo variant="primary" height={32} />
            </Link>

            

            <button 
              className="md:hidden p-2 hover:bg-muted rounded-lg transition-colors"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              aria-label="Toggle menu"
            >
              {isMenuOpen ? (
                <X className="w-6 h-6 text-foreground" />
              ) : (
                <Menu className="w-6 h-6 text-foreground" />
              )}
            </button>

            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center gap-6 lg:gap-8">
              {navLinks.map(link => (
                <Link 
                  key={link.to}
                  to={link.to} 
                  onClick={handleNavClick} 
                  className={`text-sm font-medium transition-colors relative group ${
                    isActive(link.to) 
                      ? 'text-primary' 
                      : 'text-foreground/70 hover:text-foreground'
                  }`}
                >
                  {link.label}
                  <span className={`absolute -bottom-1 left-0 h-0.5 bg-primary transition-all duration-300 ${
                    isActive(link.to) ? 'w-full' : 'w-0 group-hover:w-full'
                  }`} />
                </Link>
              ))}
              
              <button
                onClick={handleScheduleCall}
                className="border-2 border-primary text-primary hover:bg-primary hover:text-primary-foreground px-6 py-3 text-sm font-semibold rounded-full transition-all duration-300 hover:shadow-lg hover:shadow-primary/20 hover:scale-105"
              >
                Begin a Conversation
              </button>
            </div>
          </div>
          {/* Mobile Navigation */}
          {isMenuOpen && (
            <div className="md:hidden py-6 border-t border-border animate-fade-in">
              <div className="flex flex-col space-y-4">
                {navLinks.map(link => (
                  <Link 
                    key={link.to}
                    to={link.to} 
                    onClick={handleNavClick} 
                    className={`text-lg py-2 transition-colors ${
                      isActive(link.to) 
                        ? 'text-primary font-semibold' 
                        : 'text-foreground/70 hover:text-foreground'
                    }`}
                  >
                    {link.label}
                  </Link>
                ))}
                
                <button
                  onClick={handleScheduleCall}
                  className="border-2 border-primary text-primary hover:bg-primary hover:text-primary-foreground px-6 py-4 text-base font-semibold rounded-full transition-all duration-300 w-full"
                >
                  Begin a Conversation
                </button>
              </div>
            </div>
          )}
        </div>
      </nav>
      {/* Spacer to offset fixed nav height */}
      <div className="h-20 sm:h-24" />
    </>
  );
};

export default Navigation;
